import { ParametrosKey } from "src/app/shared/enums/parametros.enum";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { LocalStoreKeys } from "../shared/helpers/localstorage/local-store";
import { CustomizacaoSubmenuEnum } from "../shared/enums/CustomizacaoSubmenuEnum";
import { CustomizacaoMenuEnum } from "../shared/enums/CustomizacaoMenuEnum";
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { BooleanConverter } from '../shared/helpers/converters/boolean-converter';
import { ResponseBase } from "../models/response-base";
import { ParametersResponse } from "../models/response/parameters-response";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ParametersRequest } from "../models/request/parameters-request";

@Injectable({
    providedIn: "root"
})
export class ParametrosDataService {
    private currentParametrosSubject: BehaviorSubject<{ [key: string]: any }>;
    public currentParametros: Observable<{ [key: string]: string }>;

    temEndereco = false;
    temDadoBancario = false;

    private API = environment.API + 'portal';    
    private APIGATEWAY = environment.GATEWAY + 'assignors';

    constructor(private alertService: NewAlertService, private http: HttpClient) {
        this.currentParametrosSubject = new BehaviorSubject<{
            [key: string]: any;
        }>(JSON.parse(localStorage.getItem(LocalStoreKeys.parametros)));
        this.currentParametros = this.currentParametrosSubject.asObservable();
    }

    public get currentParametrosValue(): { [key: string]: any } {
        return this.currentParametrosSubject.value;
    }

    setCurrentParametrosValue(newParametros: { [key: string]: any }) {
        localStorage.setItem(
            LocalStoreKeys.parametros,
            JSON.stringify(newParametros)
        );
        this.currentParametrosSubject.next(newParametros);
    }

    ShowSubmenu(submenuEnum: CustomizacaoSubmenuEnum) {
        const parametros = this.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.permitirSubmenus]) {
                return parametros[ParametrosKey.permitirSubmenus].some(
                    x => x === submenuEnum
                );
            }
        }

        return true;
    }

    ShowMenu(menuEnum: CustomizacaoMenuEnum) {
        const parametros = this.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.permitirMenus]) {
                return parametros[ParametrosKey.permitirMenus].some(
                    x => x == menuEnum
                );
            }
        }

        return true;
    }

    loadNotifications() {
        const options = {
            autoClose: false,
            keepAfterRouteChange: true,
        };

        const parametros = this.currentParametrosValue;

        if (parametros[ParametrosKey.temEndereco]) {
            this.temEndereco = BooleanConverter.getBoolean(parametros[ParametrosKey.temEndereco]);
        }

        if (parametros[ParametrosKey.temDadoBancario]) {
            this.temDadoBancario = BooleanConverter.getBoolean(parametros[ParametrosKey.temDadoBancario]);
        }

        this.alertService.clearNotifications();

        if (!this.temEndereco) {
            this.alertService.notificationWarning(
                'Endereço',
                'Você ainda não informou o seu endereço, para cadastrar navegue até Administrativo > Dados da empresa',
                options
            );
        }

        // if (!this.temDadoBancario) {
        //     this.alertService.notificationWarning(
        //         'Dado Bancário',
        //         'Você ainda não informou nenhum dado bancário, para cadastrar navegue até Administrativo > Dados bancários',
        //         options
        //     );
        // }
    }

    getParameters(): Observable<ResponseBase<ParametersResponse>> {
        return this.http.post<ResponseBase<ParametersResponse>>(`${this.API}/parametros`,{parametros: [3]});
    }

    updateParameters(assignorGuid: string, managerGuid: string, parameters: { [key: string]: string }[]): Observable<ResponseBase<boolean>> {        
        return this.http.put<ResponseBase<boolean>>(`${this.APIGATEWAY}/${assignorGuid}/managers/${managerGuid}/parameters`, parameters);
    }
}
